import { useStudentNamesAndImagesQuery } from "@hex-insights/verita-romania.shared";

export function useViewerStudentNamesAndImages() {
	return useStudentNamesAndImagesQuery({
		variables: {
			filters: {
				relationships: [
					{
						guardian: [
							{
								person: [
									{
										user: [{ isCurrentEQ: true }],
									},
								],
							},
						],
					},
				],
			},
		},
	});
}
